import { render } from "./MypageTab.vue?vue&type=template&id=46b71cac"
import script from "./MypageTab.vue?vue&type=script&lang=js"
export * from "./MypageTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__